import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import validate from 'validate.js';
import Grid from '@material-ui/core/Grid';
import FormTextField from '../legacyForm/FormTextField';
import Pesel from '../../utils/pesel';

const required = value => value ? undefined : 'Pole jest wymagane';
const pesel = value => new Pesel(value).isValid() ? undefined : 'Numer pesel nie jest prawidłowy';
const email = value => validate.single(value, { email: true }) ? 'Ades nie jest prawidłowy' : undefined;
const phoneNumber = isOptional => value => {
  if (!value || /^\s*$/.test(value)) {
    if (!isOptional) return 'Pole jest wymagane';
    return undefined;
  }

  if (!/^\s*(\d\s*){9}$/.test(value)) return 'Numer telefonu musi składać się z 9 cyfr';
  return undefined;
};

const phoneNumberRequired = phoneNumber(false);

const BudgetApplicationListOfSupportPerson = ({ requiredData, readonly }) => (
  <div>
    {requiredData.name && <div><Field
      name="person.name"
      component={FormTextField}
      label="Imię"
      fullWidth
      validate={required}
      disabled={readonly}
    /></div>}
    {requiredData.lastName && <div><Field
      name="person.lastName"
      component={FormTextField}
      label="Nazwisko"
      fullWidth
      validate={required}
      disabled={readonly}
    /></div>}
    {requiredData.address && <div><Field
      name="person.address"
      component={FormTextField}
      label="Adres zamieszkania"
      fullWidth
      validate={required}
      disabled={readonly}
    /></div>}
    <Grid container spacing={1}>
      {requiredData.pesel && <Grid item xs><Field
        name="person.pesel"
        component={FormTextField}
        label="Pesel"
        validate={[requiredData.peselOptional ? undefined : required, pesel]}
        disabled={readonly}
      /></Grid>}
      {requiredData.phoneNumber && <Grid item xs><Field
        name="person.phoneNumber"
        component={FormTextField}
        label="Numer telefonu"
        validate={phoneNumberRequired}
        disabled={readonly}
      /></Grid>}
      {requiredData.email && <Grid item xs><Field
        name="person.email"
        component={FormTextField}
        label="Adres e-mail"
        type="email"
        validate={[required, email]}
        disabled={readonly}
      /></Grid>}
    </Grid>
  </div>
);

BudgetApplicationListOfSupportPerson.propTypes = {
  requiredData: PropTypes.object.isRequired,
  readonly: PropTypes.bool,
};

export default BudgetApplicationListOfSupportPerson;



// WEBPACK FOOTER //
// ./src/components/budget/BudgetApplicationListOfSupportPerson.js